import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Paper } from '@mui/material';
import Search from '../../../../../../assets/svg/search.svg';
import { FeedbackAlert, Image } from '../../../../../../components';
import FeatureSearchInput from '../FeatureSearchInput';
import { getFilteredEvents, resetFilteredEvents } from '../../../../../../core/events/action';
import { formatDate } from '../../../../../../utils';

function DashboardSearchBar() {
  const dispatch = useDispatch();
  const [isFeedbackVisible, setIsFeedbackVisible] = useState(false);
  const [venueFilter, setVenueFilter] = useState({
    name: '',
    date: '',
    location: '',
  });

  const areFiltersEmpty = useMemo(
    () => Object.keys(venueFilter).every((key) => venueFilter[key] === ''),
    [venueFilter],
  );
  useEffect(() => {
    dispatch(
      getFilteredEvents(
        {
          ...venueFilter,
          start_date: formatDate(new Date(), 'YYYY-MM-DD'),
        },
        (data) => !data?.length && setIsFeedbackVisible(true),
      ),
    );
  }, []);

  useEffect(() => {
    if (!areFiltersEmpty) return;
    // dispatch(resetFilteredEvents());
    dispatch(
      getFilteredEvents(
        {
          ...venueFilter,
          start_date: formatDate(new Date(), 'YYYY-MM-DD'),
        },
        (data) => !data?.length && setIsFeedbackVisible(true),
      ),
    );
  }, [areFiltersEmpty, dispatch]);

  const handleSearch = () => {
    if (areFiltersEmpty) return;
    dispatch(
      getFilteredEvents(
        {
          ...venueFilter,
          ...(venueFilter.date !== '' && { date: formatDate(venueFilter.date, 'YYYY-MM-DD') }),
        },
        (data) => !data?.length && setIsFeedbackVisible(true),
      ),
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVenueFilter((prev) => ({
      ...prev,
      [name]: name === 'date' ? value : value,
    }));
  };

  return (
    <>
      {/* <Paper elevation={3} sx={{ borderRadius: 10, width: '80vw' }}>
        <Grid container>
          <Grid item xs={4}>
            <FeatureSearchInput
              label="Name"
              name="name"
              fieldValue={venueFilter?.name}
              onChange={handleChange}
              placeholder="What?"
            />
          </Grid>
          <Grid item xs={3}>
            <FeatureSearchInput
              label="Date"
              name="date"
              fieldValue={venueFilter?.date}
              onChange={handleChange}
              inputType="date"
              placeholder="When?"
            />
          </Grid>
          <Grid item xs={3}>
            <FeatureSearchInput
              label="Location"
              name="location"
              fieldValue={venueFilter?.location}
              onChange={handleChange}
              placeholder="Where?"
            />
          </Grid>
          <Grid item xs={2} display="flex" alignItems="center" justifyContent="center">
            <IconButton
              sx={{ width: '100%', height: '100%', borderRadius: 0 }}
              onClick={handleSearch}>
              <Image src={Search} alt="search icon" />
            </IconButton>
          </Grid>
        </Grid>
      </Paper> */}
      <FeedbackAlert
        message="No events were found!"
        severity="warning"
        open={isFeedbackVisible}
        handleClose={() => setIsFeedbackVisible(false)}
      />
    </>
  );
}

export default DashboardSearchBar;
